import HomeAITransport from "./HomeAITransport";
import HomeBanner from "./HomeBanner";
import HomeContact from "./HomeContact";
import HomeCounter from "./HomeCounter";
import HomeFeatures from "./HomeFeatures";
import HomeIndustries from "./HomeIndustries";
import HomeInsight from "./HomeInsight";
import HomeLogos from "./HomeLogos";
import HomeMap from "./HomeMap";
import HomeNews from "./HomeNews";
import HomeServices from "./HomeServices";
import HomeSolutions from "./HomeSolutions";
import HomeTab from "./HomeTab";
import HomeTestimonial from "./HomeTestimonial";
import HomeWareManagement from "./HomeWareManagement";
import React from "react";
import { Helmet } from "react-helmet-async";
import ClientOnly from "../../components/ClientOnly";

export default function Home({ initialData }) {
  const slides = [

    {
      bgImage: "/assets/images/banner-slider-image2.webp",
      mobileImage: "/assets/images/banner-right-image2.webp",
      rightImage: "/assets/images/second-banner-image4.webp",
      altText: "AI Supply Chain",
      title: "Intelligent Automation for Limitless Logistics",
      description:
        "Empowering Businesses with Predictive Insights, Seamless Coordination, and Real-Time Decision-Making — All Driven by AI Precision.",
      link: "/contact-us",
      buttonText: "Discover Now",
      vectorImages: [
        {
          src: "/assets/images/second-banner-image1.webp",
          className: " second-vector1 vector-image1",
        },
        {
          src: "/assets/images/second-banner-image2.webp",
          className: "second-vector2 vector-image2",
        },
        {
          src: "/assets/images/second-banner-image3.webp",
          className: "second-vector3 vector-image3",
        },

        {
          src: "/assets/images/second-banner-image5.webp",
          className: "vector-image4",
        },
      ],
    },



    {
      bgImage: "/assets/images/banner-slider-image1.webp",
      mobileImage: "/assets/images/banner-right-image1.webp",
      rightImage: "/assets/images/first-banner-image4.webp",
      altText: "AI Supply Chain",
      title: "AI-Driven Platform for  <br/> a Fully Autonomous Supply Chain",
      description:
        "Revolutionizing Enterprises with Agile, Self-Optimizing  <br/> AI Logistics for Lasting Impact and Effortless Adaptation",
      link: "/contact-us",
      buttonText: "Discover Now",
      vectorImages: [
        {
          src: "/assets/images/first-banner-image1.webp",
          className: " vector-image1",
        },
        {
          src: "/assets/images/first-banner-image2.webp",
          className: "vector-image2",
        },
        {
          src: "/assets/images/first-banner-image3.webp",
          className: "vector-image3",
        },
      ],
    },

  ];



  const tabData = [
    {
      title: "First Mile",
      heading: " Kickstart Your Supply Chain with Precision",
      description:
        " Our platform ensures the smooth movement of goods from suppliers to warehouses with intelligent planning and real-time visibility. By optimizing pick-ups, scheduling, and load management, First Mile efficiency increases, reducing delays and operational costs.",
      link: "/first-mile-logistics",
      image: "/assets/images/last-mile-image2.webp",
      testimonial: {
        text: "Mobility Infotech’s First Mile solution streamlined our supplier pickups, improving lead times by 20%.",
        name: " Riya Mehra",
        designation: " Operations Manager, Prime Retail Pvt. Ltd.",
      },
    },
    {
      title: "Mid Mile",
      heading: "Seamless Transport Between Hubs",
      description:
        " Enhance the efficiency of inter-warehouse and regional transport with AI-driven routing, load optimization, and predictive insights. Mid Mile automation reduces transit times, fuel costs, and bottlenecks while maintaining supply chain continuity.",
      link: "/middle-mile-logistics",
      image: "/assets/images/last-mile-image4.webp",
      testimonial: {
        text: "We achieved faster inter-warehouse deliveries and cut transport costs significantly with Mobility Infotech.",
        name: "Rahul Verma",
        designation: "OLogistics Director, Apex Distributors",
      },
    },
    {
      title: "Route Optimization",
      heading: "Smart Route Optimization for Efficient Deliveries",
      description:
        "Enhance delivery operations with intelligent route optimization that reduces costs, saves time, improves fleet efficiency, and ensures faster, more reliable shipments. Powered by advanced automation, real-time data insights, and scalable solutions, our platform transforms logistics operations for growing businesses.",
      link: "/route-optimization-and-planning",
      image: "/assets/images/tabber-image1.webp",
      testimonial: {
        text: "Route optimization cut delivery times by 25%, lowered overall costs, boosted customer satisfaction, and enhanced operational efficiency.",
        name: "Amit Sharma",
        designation: "Head of Operations, S.K. Logistics Pvt. Ltd.",
      },
    },
    {
      title: "Last Mile",
      heading: " Deliver Excellence to Your Customers’ Doorstep",
      description:
        " Ensure timely, cost-effective, and reliable deliveries with optimized final-mile planning. Our AI-driven system improves route efficiency, reduces delivery errors, and boosts customer satisfaction, even in high-demand urban areas.",
      link: "/last-mile-delivery-logistics",
      image: "/assets/images/last-mile-image1.webp",
      testimonial: {
        text: "Customer complaints dropped by 30% after implementing Last Mile optimization with Mobility Infotech",
        name: "Ankit Sharma",
        designation: "Logistics Head, G.K Logistics Pvt. Ltd.",
      },
    },
    {
      title: "TMS Integration",
      heading: " Centralize and Simplify Your Logistics Operations",
      description:
        "Seamlessly integrate our platform with your existing Transportation Management Systems. Gain real-time visibility, automated workflows, and centralized control over your entire supply chain, reducing manual errors and operational complexity.",
      link: "/transportation-management-services-tms",
      image: "/assets/images/last-mile-image3.webp",
      testimonial: {
        text: "Integration was effortless, and now our entire supply chain operates in real time.",
        name: "Sneha Kapoor",
        designation: "Supply Chain Manager, Horizon Enterprises",
      },
    },
    {
      title: "Fleet management",
      heading: " Maximize Fleet Efficiency and Reduce Costs",
      description:
        "Monitor, track, and optimize every vehicle in your fleet with AI-powered insights. Improve vehicle utilization, reduce downtime, lower fuel consumption, and ensure proactive maintenance for smooth, uninterrupted operations.",
      link: "/warehouse-management-system-wms",
      image: "/assets/images/last-mile-image5.webp",
      testimonial: {
        text: "Fleet utilization improved by 15% while maintenance costs dropped by 10% after deploying Mobility Infotech’s Fleet Management.",
        name: "Vikram Singh",
        designation: "Fleet Operations Lead, Speed Logistics",
      },
    },
    {
      title: "Shipment tracking",
      heading: " Real-Time Visibility at Your Fingertips",
      description:
        " Keep customers and teams informed with precise, real-time tracking of shipments across all stages. Increase transparency, reduce exceptions, and enhance the overall delivery experience with predictive alerts and proactive updates.",
      link: "/shipment-tracking",
      image: "/assets/images/last-mile-image6.webp",
      testimonial: {
        text: "Shipment tracking transparency boosted client satisfaction and reduced support calls by 25%.",
        name: "Neha Agarwal",
        designation: "Customer Experience Head, Star Freight Solutions",
      },
    },
  ];


  const featureData = {
    subtitle: "Data Intelligence",
    heading: "Get More Value from <br> Every Mile ",
    description:
      "Leverage AI-driven analytics to track CAC, LTV, and sales, benchmark performance, uncover hidden opportunities, and make smarter business decisions.  Turning data into actionable insights.",
    buttonText: "About First Mile",
    link: "/first-mile-logistics",
    image: "/assets/images/intelligence-image.webp",
    imageAlt: "Data Intelligence Illustration",
    animate: true,
    animationWow: "animate__slideInLeft",
    delay: "0.2s",
    duration: "2s",
  };


  const RountingData = {
    subtitle: "Smart Routing",
    heading: "Optimize Routes &  Costs with AI",
    description:
      " AI-driven routing reduces delivery times, lowers costs, and  improves fleet efficiency with real-time insights.",
    buttonText: "About Routes",
    link: "/route-optimization-and-planning",
    image: "/assets/images/intelligence-image1.webp",
    imageAlt: "Data Intelligence Illustration",
    animate: true,
    animationWow: "animate__slideInLeft",
    delay: "0.2s",
    duration: "2s",
  };


  const clientsData = {
    subtitle: "Customer stories",
    title: "Discover why leaders choose Mobility Infotech",
    slides: [
      {
        quoteIcon: "/assets/images/kiara-image1.webp",
        image:
          "/assets/images/testimonial-arrow.webp",
        quote:
          "Mobility Infotech’s TMS transformed our last-mile chaos into a smooth, measurable operation. Real-time ETAs and automated route re-optimization cut delivery delays by nearly 28% and our customer complaints dropped dramatically. Integration with our ERP was seamless — the team was with us every step.",
        name: "Head of Operations ",
        designation: "KiranaKart , India",
      },
      {
        quoteIcon: "/assets/images/logistics-new-icons.webp",
        image:
          "/assets/images/testimonial-arrow.webp",
        quote:
          "We needed visibility across 250+ weekly shipments — Mobility’s dashboard gave us it and more. Instant exception alerts, proof-of-delivery capture, and easy driver app adoption improved our OTIF and reduced detention costs. Solid product and reliable support.",
        name: "COO, SpiceRoute ",
        designation: "Logistics , India",
      },
      {
        quoteIcon: "/assets/images/evergreen-icons.webp",
        image:
          "/assets/images/testimonial-arrow.webp",
        quote:
          "Cold-chain tracking and compliance were non-negotiable. Mobility Infotech’s TMS gave us precise temperature logs, automated compliance reports and dependable carrier workflows. It’s the backbone of our European distribution now.",
        name: "Supply Chain Manager ",
        designation: "EverGreen Pharma Uk",
      },
      {
        quoteIcon: "/assets/images/evergreen-icons2.webp",
        image:
          "/assets/images/testimonial-arrow.webp",
        quote:
          "Switching to Mobility’s TMS was the best ROI decision we made last year. Route optimization alone cut fuel spend and driver hours significantly; customers love the live-tracking links. Implementation was fast and the analytics help us make smarter weekly decisions.",
        name: "VP Logistics ",
        designation: "BlueHarbor Foods , USA",
      },

      {
        quoteIcon: "/assets/images/tranasia-image.webp",
        image:
          "/assets/images/testimonial-arrow.webp",
        quote:
          "From multi-hub consolidation to reverse logistics, Mobility’s platform handled it all. Custom KPIs, actionable dashboards, and a proactive account team helped us scale operations without headaches. Clear wins in cost and customer satisfaction.",
        name: "Head of Supply",
        designation: " TransAsia Electronics , India",
      },
    ],
  };

  const industriesData = {
    subtitle: "Industries We Serve",
    title: "Predict. Assist. Delight. Repeat.",
    items: [
      { title: "Logistics", desc: " Boost operational efficiency with Mobility TMS by optimising routes, reducing costs, and enhancing real-time visibility across your supply chain.", img: "/assets/images/logistics-image1.webp", link1: "/contact-us", btn1: "Request More", link2: "/contact-us", btn2: "Explore Logistics", },
      { title: "Consumer Products", desc: " Ensure timely deliveries and streamline distribution with Mobility TMS, minimising delays, cutting operational costs, and improving customer satisfaction.", img: "/assets/images/logistics-imag2.webp", link1: "/contact-us", btn1: "Request More", link2: "/contact-us", btn2: "Discover Products", },
      { title: "Automotive", desc: " Optimise automotive logistics with Mobility TMS, improving delivery efficiency, reducing costs, & maintaining smooth supply chain operations.", img: "/assets/images/logistics-image3.webp", link1: "/contact-us", btn1: "Request More", link2: "/contact-us", btn2: "See Automotive", },
      { title: "High Tech & Electronics", desc: " Accelerate high-tech & electronics distribution with Mobility TMS, ensuring precise deliveries, minimising errors, & maximising operational efficiency.", img: "/assets/images/logistics-image4.webp", link1: "/contact-us", btn1: "Request More", link2: "/contact-us", btn2: "View Capabilities", },
      { title: "Pharma & Healthcare", desc: "Ensure safe, timely delivery of medicines and medical supplies with Mobility TMS, while reducing errors and maintaining compliance.", img: "/assets/images/logistics-image5.webp", link1: "/contact-us", btn1: "Request More", link2: "/contact-us", btn2: "Learn  Healthcare", },
    ],
  };


  const counterData = {
    title: "Designed to scale seamlessly",
    counters: [
      { value: 2, suffix: "Bn+", label: "Shipments Handled" },
      { value: 97, suffix: "Bn+", label: "Checkpoints Generated" },
      { value: 99.9, suffix: "%", label: "On-Time Deliveries" },
      { prefix: "", value: 400, suffix: " K+", label: "Vendors Onboarded" },
    ],
  };

  return (
    <>

      <Helmet>
        <link rel="preload" href="/assets/images/banner-slider-image2.webp" as="image" type="image/webp" />
        <link rel="preload" href="/assets/images/second-banner-image4.webp" as="image" type="image/webp" />
        <link rel="preload" href="/assets/images/banner-right-image2.webp" as="image" type="image/webp" media="(max-width: 767px)" />
      </Helmet>





      <HomeBanner slides={slides} extraClass="home-new-banner" />
      <HomeSolutions />
      <HomeTab data={tabData} />
      <HomeServices />
      <HomeLogos />
      <HomeIndustries data={industriesData} />
      <HomeAITransport />
      <HomeFeatures data={featureData} />
      <HomeWareManagement />
      <div className="border-remove"> <HomeFeatures data={RountingData} /></div>
      <HomeCounter data={counterData} />
      <HomeMap />
      <HomeTestimonial data={clientsData} />
      <HomeNews />
      <ClientOnly><HomeContact /></ClientOnly>
      <HomeInsight initialData={initialData} />

    </>
  )
}
